import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	dismissFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonsModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonsModalExplanation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonsModalBulletOne: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonsModalBulletTwo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privacyPolicy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loomAdControlsTrigger: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonsModalBulletTwoAppify: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dismissFlagTitle: {
		id: 'loom-utils.ui.ad-controls.dismiss-flag-title',
		defaultMessage: 'Got it, thanks for letting us know',
		description:
			'Title of the flag that shows up when a user dismisses one of the loom videos cross-flow touchpoints.',
	},
	dismissFlagDescription: {
		id: 'loom-utils.ui.ad-controls.dismiss-flag-description',
		defaultMessage: "You won't see this here as often.",
		description:
			'Description of the flag that shows up when a user dismisses one of the loom videos cross-flow touchpoints.',
	},
	reasonsModalTitle: {
		id: 'loom-utils.ui.ad-controls.reasons-modal-title',
		defaultMessage: 'Why am I seeing this?',
		description:
			'Title of the reasons modal explaining why the loom cross-flow touchpoint is being shown',
	},
	reasonsModalExplanation: {
		id: 'loom-utils.ui.ad-controls.reasons-modal-explanation',
		defaultMessage:
			"We think that <strong>Loom</strong> will improve your team's productivity. The recommendation is based on:",
		description: 'Explanation as to why the loom cross-flow touchpoint is being shown',
	},
	reasonsModalBulletOne: {
		id: 'loom-utils.ui.ad-controls.reasons-modal-bullet-one',
		defaultMessage: 'the size of your team',
		description: 'First bullet point of the reasons modal for loom cross-flow touchpoint ad',
	},
	reasonsModalBulletTwo: {
		id: 'loom-utils.ui.ad-controls.reasons-modal-bullet-two',
		defaultMessage: 'your existing Atlassian products',
		description: 'Second bullet point of the reasons modal for loom cross-flow touchpoint ad',
	},
	privacyPolicy: {
		id: 'loom-utils.ui.ad-controls.privacy-policy',
		defaultMessage: 'Learn more about your data privacy with Atlassian',
		description: "Link to Atlassian's privacy policy",
	},
	loomAdControlsTrigger: {
		id: 'loom-utils.ui.ad-controls.loom-ad-controls-trigger',
		defaultMessage: 'Loom ad controls actions',
		description: 'Ad controls trigger icon',
	},
	reasonsModalBulletTwoAppify: {
		id: 'loom-utils.ui.ad-controls.reasons-modal-bullet-two-appify',
		defaultMessage: 'your existing Atlassian apps',
		description: 'Second bullet point of the reasons modal for loom cross-flow touchpoint ad',
	},
});
export default messages;
